import React from 'react';
import Helmet from "../Helmet";
import Grid from 'material-ui/Grid';
// import ContactForm from './form';
import { withRouter } from 'react-router-dom';
import PAGE_CONFIG  from '../../config/contact.json';
import { initGA } from '../GA'; 
import Button from 'material-ui/Button';

class contact extends React.Component{
  constructor(props){
    super(props)
    this.submited = this.submited.bind(this)
  }
  componentDidMount(){
    initGA();
  }
  
  // submit
  submited(result){
    this.props.sendContact(result)
    .then((res) => {
      this.props.history.push('/contact/result');
    })
    .catch((e) => {
      this.props.history.push('/contact/error');
    })
  }
  mailTo(e) {
    window.location.href = "mailto:"+PAGE_CONFIG.mailto;
    e.preventDefault();
  }
  render(){
    return (
      <div className="center-container">
        <Helmet title={PAGE_CONFIG.title} description={PAGE_CONFIG.description} canonical={PAGE_CONFIG.canonical} />
          
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <div className="contents-title-cont">
                <h1 className="contents-title">{PAGE_CONFIG.title}</h1>
                <p className="contents-sub-title">{PAGE_CONFIG.sub_title}</p>
                
              </div>
              <div className="contact-form">
                <div className="contact-form-inner box-shadow">
                  <p>{PAGE_CONFIG.comment}</p>
                  <div>
                    <Button type="button" onClick={this.mailTo} variant="raised" size="medium" style={{marginTop:20}} color="primary">
                    お問合せはこちらから
                    </Button>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
    )
  }
}

export default withRouter(contact);


// WEBPACK FOOTER //
// ./src/component/contact/index.js